const useConsultantRole = () => {
  const getConsultantRole = role => {
    switch (role) {
      case 'claim_group_access_lead_consultant':
        return 'lead_consultant';
      case 'claim_group_access_suporting_consultant':
        return 'supporting_consultant';
      default:
        return [''];
    }
  };
  return [getConsultantRole];
};
export default useConsultantRole;